export type RemoteFormRefreshDecision =
  | 'unchanged'
  | 'reload'
  | 'preserve-and-notify'
  | 'preserve-silently';

export function decideRemoteFormRefresh(
  remoteChange: { changed: boolean; newlyObserved: boolean },
  isDirty: boolean,
): RemoteFormRefreshDecision {
  if (!remoteChange.changed) {
    return 'unchanged';
  }
  if (!isDirty) {
    return 'reload';
  }
  return remoteChange.newlyObserved ? 'preserve-and-notify' : 'preserve-silently';
}
